import { ErrorWrapper, ResponseWrapper } from '../util'
import { RoomBaseApiService } from '@/core/service/room.baseapi.service'

class CamStudyService extends RoomBaseApiService {
    constructor(props) {
        super(props)
    }

    async getCamStudyUserProfile(data) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/users/${data?.userId}/profile?roomId=${data?.roomId}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyUserInfo(roomId, userId) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/${roomId || this.getRoomId()}/users/${userId}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyRoomInfo(roomId) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/${roomId || this.getRoomId()}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async camStudyUserList(roomId) {
        try {
            const response = await this.request().get(`/api/v3/camstudy/${roomId || this.getRoomId()}/users`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async camStudyUserBanList(roomId) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/${roomId || this.getRoomId()}/users/bans`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeStopwatchState(state) {
        try {
            const response = await this.request().post(`/api/v3/room/camstudy/${this.getRoomId()}/changeStopwatchState`,{
                state
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async resetStopwatch(resetData = false) {
        try {
            const response = await this.request().post(`/api/v3/room/camstudy/${this.getRoomId()}/resetStopwatch`,{
                totalTimeSeconds: 0,
                resetData
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getTodayCamStudyData() {
        try {
            const response = await this.request().get(`/api/v3/room/camstudy/${this.getRoomId()}/getTodayCamStudyData`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async createTodayCamStudyUserData() {
        try {
            const response = await this.request().post(`/api/v3/room/camstudy/${this.getRoomId()}/createTodayCamStudyUserData`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async modifyCamStudy(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/camstudy/${this.getRoomId()}/modifyCamStudy`,{
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async addBanUser(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/camstudy/${this.getRoomId()}/addBan`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async removeBanUser(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/camstudy/${this.getRoomId()}/removeBan`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeStudyStatus(userId, data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/camstudy/${this.getRoomId()}/users/${userId}/study-status`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async addUserPoint(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/camstudy/${this.getRoomId()}/addUserPoint`, data)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getWhiteNoisePlayList(){
        try{
            const response = await this.request({ auth: true }).get('/api/v3/userItem/whiteNoise');
            return new ResponseWrapper(response, response.data.data)
        }catch(error){
            throw new ErrorWrapper(error)
        }
    }

    async changeWhiteNoiseStatus(data){
        const {userId, whiteNoiseStatus} = data;
        try{
            const response = await this.request({ auth: true }).post(`/api/v3/camstudy/${this.getRoomId()}/users/${userId}/whitenoise-status`, {
                whiteNoiseStatus
            });
            return new ResponseWrapper(response, response.data.data)
        }catch(error){
            throw new ErrorWrapper(error)
        }
    }

    async getPersonalSetting() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/room/personal/setting`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async modifyPersonalSetting(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/personal/setting`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyRoomHashTagList() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/room/camstudy/${this.getRoomId()}/hashtags`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyRoomImage() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/room/camstudy/${this.getRoomId()}/roomImages`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async modifyRoomImageUrl(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/camstudy/${this.getRoomId()}/roomImages`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getUserDdayWidget() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/user/widget/dday`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getUploadImageSasUrl(data) {
        try {
            const queryParam = data?.type ? `?uploadType=${data?.type}` : '';
            const response = await this.request({ auth: true }).get(`/api/v3/room/camstudy/${this.getRoomId()}/roomImages/sas-url${queryParam}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyUserStopWatchSetting(roomId, userId) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/${roomId || this.getRoomId()}/users/${userId}/stopWatch`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async saveUserStopWatchSetting(roomId, sendEvent, data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/camstudy/${roomId || this.getRoomId()}/stopWatch`, {
                stopWatchSetting: data,
                sendEvent: sendEvent
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async modifyCamStudyMyMsg(roomId, userId, myMsg) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/camstudy/${roomId || this.getRoomId()}/modifyUserMyMsg`, {
                myMsg
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async inviteUser(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/${this.getRoomId()}/invite`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async isJoinedEmail(email) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/verify-email`, {
                params: {
                    email
                }
            })

            if(response.data?.code === 'RT_WRONG_PARAMETER') {
                return false;
            }

            return true;
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async checkUserPremium() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/user/premium`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyMyMsg(roomId, userId) {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/${roomId || this.getRoomId()}/users/${userId}/myMsg`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeCamStudyType(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/camstudy/room/${data.roomId || this.getRoomId()}/change/room-type?roomLevel=${data.roomLevel}`)
            return new ResponseWrapper(response, response.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeCamStudyUserNickname(data) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/camstudy/room/${data.roomId || this.getRoomId()}/users/profiles/nickname`, {
                ...data
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getCamStudyTrialInfo() {
        try {
            const response = await this.request({ auth: true }).get(`/api/v3/camstudy/user/trial-info`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const camStudyService = new CamStudyService()
